import React from 'react';
import { PRODUCT_DATA } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
export const PackComposite: React.FC = () => {
  return <section className="py-20 px-4 bg-white overflow-hidden" data-id="element-207">
      <div className="container mx-auto max-w-5xl text-center" data-id="element-208">
        <h2 className="text-3xl md:text-5xl font-extrabold text-blue-900 mb-4" data-id="element-209">
          Todo esto es tuyo hoy
        </h2>
        <p className="text-xl text-gray-600 mb-16" data-id="element-210">
          El arsenal completo para transformar tu academia de folclore
        </p>

        <div className="relative h-[350px] md:h-[500px] w-full max-w-4xl mx-auto cursor-pointer group" onClick={scrollToOffer} data-id="element-211">
          {/* Glow effect */}
          <div className="absolute inset-0 bg-orange-400/20 blur-[100px] rounded-full z-0" data-id="element-212"></div>

          {/* Main Product */}
          <div className="absolute left-1/2 -translate-x-1/2 top-[3%] w-[60%] md:w-[45%] z-30 transition-transform duration-500 group-hover:scale-110" data-id="element-213">
            <img src={PRODUCT_DATA.mainImage} alt="Megapack Principal" className="w-full h-auto drop-shadow-2xl" data-id="element-214" />
          </div>

          {/* Note: In a real implementation with separate images for bonuses, we would position them absolutely here.
            Since we only have one main composite image provided in the prompt, we'll use that as the centerpiece.
            The prompt asked for absolute positioning of 5 images, but we only have 1 URL.
            I will simulate the effect using the main image. */}
        </div>

        <p className="text-sm text-gray-500 mt-8" data-id="element-215">
          Haz clic en la imagen para ver la oferta
        </p>
      </div>
    </section>;
};